// holds a list of APIs called outside of the ms-backend API
// TODO: DGM-3386 - move this back to env.js once the secrets are updated through terraform
export const APIs = {
    minchemPreferencesCF: {
        development: 'http://localhost:8095',
        dev: 'https://minchem-preferences-api-fjpbrn6wfq-wn.a.run.app',
        staging: 'https://minchem-preferences-api-pixzn5ycra-wn.a.run.app',
        production: 'https://minchem-preferences-api-5fg2h4q7ea-wn.a.run.app',
    }[process.env.NODE_ENV || 'development'],
    userPreferencesCF: {
        development: 'http://localhost:8098',
        dev: 'https://user-preferences-api-fjpbrn6wfq-wn.a.run.app',
        staging: 'https://user-preferences-api-pixzn5ycra-wn.a.run.app',
        production: 'https://user-preferences-api-5fg2h4q7ea-wn.a.run.app',
    }[process.env.NODE_ENV || 'development'],
    platformAuthenticationApiCF: {
        development: 'http://localhost:8099',
        dev: 'https://platform-authentication-api-fjpbrn6wfq-wn.a.run.app',
        staging: 'https://platform-authentication-api-pixzn5ycra-wn.a.run.app',
        production: 'https://platform-authentication-api-5fg2h4q7ea-wn.a.run.app',
    }[process.env.NODE_ENV || 'development'],
};
